const e = "label_XUoFW", l = "label__noPadded_rpJ9v", o = "selector_z2id-", a = {
  label: e,
  label__noPadded: l,
  selector: o
};
export {
  a as default,
  e as label,
  l as label__noPadded,
  o as selector
};
//# sourceMappingURL=selector.module.scss.js.map
